<template>
	<div>
		<el-row :gutter="20" class="top-block">
	    <Breadcrumb :route="this.$route"></Breadcrumb>
	  </el-row>

	  <el-row v-if="!inEditingMode">
	    <el-col :xs="8" :sm="8" :lg="12">
	      <el-button v-if="from == ''" type="normal" @click.prevent="goBack" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
	      </el-button>
	      <el-button v-if="from !=''" type="info" @click.prevent="goBackReport" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
	      </el-button>
	    </el-col>
	    <el-col :xs="16" :sm="16" :lg="12" style="text-align: right">
	      <el-button v-if="canEdit" size="mini" type="warning" @click.prevent="handleDraft('basicDataForm')">暫存 <i
	          class="el-icon-s-claim"></i></el-button>
	      <el-button v-if="canEdit" size="mini" type="primary" @click.prevent="handleSign('basicDataForm')" class="mr-20">送簽核 <i
	          class="el-icon-s-claim"></i></el-button>
	    </el-col>
	  </el-row>

	  <!-------------------------------------------------------------------->
    <!-- form -->
    <!-------------------------------------------------------------------->
   
    <!--    基本資料-->
	  <el-row v-if="!inEditingMode">
	    <el-col :xs="24" :sm="24" :lg="24">
	      <el-main>
	        <el-card class="box-card">
	          <div slot="header" class="clearfix">
	            <span>基本資料</span>
	            <el-button style="float: right; padding: 2px 0; margin-top: -12px" type="text">
	              <el-tag type="info">申請單狀態 : {{basicForm.status | fmtSignResult }}</el-tag>
	            </el-button>
	            <!--            <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
	          </div>
	          <div>
	            <el-form :model="basicForm" :rules="rules" ref="basicDataForm" label-width="100px">
	              <el-row>
	                <el-col :xs="24" :sm="24" :md="8">
	                  <el-form-item label="填單人" prop="userObj.username" >
	                    <el-input  readonly v-model="basicForm.userObj.username"></el-input>
	                  </el-form-item>
	                </el-col>
	                <el-col :xs="24" :sm="24" :md="8">
	                  <el-form-item label="標題" prop="title">
	                    <el-input v-if="basicForm.status === 'draft'" v-model="basicForm.title" autocomplete="off"></el-input>
	                    <el-input v-if="basicForm.status !== 'draft'" readonly v-model="basicForm.title" autocomplete="off"></el-input>
	                  </el-form-item>
	                </el-col>
	                <el-col :xs="24" :sm="24" :md="8">
	                  <el-form-item label="報表日期" prop="startDate" >
	                    <el-date-picker v-if="basicForm.status ==='draft'"  type="date" placeholder="選擇日期" v-model="basicForm.startDate"></el-date-picker>
	                    <el-date-picker v-if="basicForm.status !=='draft'" readonly type="date" placeholder="選擇日期" v-model="basicForm.startDate"></el-date-picker>
	                  </el-form-item>
	                </el-col>
	                <el-col :xs="24" :sm="24" :md="8">
	                  <el-form-item label="申請單編號" prop="reqPayNo" >
	                    <el-input  readonly v-model="basicForm.reqPayNo"></el-input>
	                  </el-form-item>
	                </el-col>
	                <el-col :xs="24" :sm="24" :md="8">
	                  <el-form-item label="關聯日報" prop="relatedTodoId" >
	                  	<el-select :xs="24" v-model="basicForm.relatedTodoId" placeholder="選擇日報" :disabled="basicForm.status !== 'draft'">
								        <el-option
								            v-for="item in dailyRecordTableData"
								            :key="item.id"
								            :label="cookLabel(item)"
								            :value="item.id">
								        </el-option>
								      </el-select>
	                  </el-form-item>
	                </el-col>
	              </el-row>
	            </el-form>
	          </div>
	        </el-card>
	      </el-main>
	    </el-col>
	  </el-row>

	  <!--    今日的交通工具與里程數計算 -->
	  <el-row v-if="!inEditingMode"> 
	    <el-col :xs="24" :sm="24" :lg="24">
	      <el-main class="taskMain">
	        <el-card class="box-card">
	          <div slot="header" class="clearfix">
	            <span>交通工具與里程數</span>
	            <el-button v-if="canEdit" type="primary" @click.prevent="handleAddDriving" class="card-header-btn mr-20" id="add_driving_btn">
	                <i class="el-icon-circle-plus-outline"></i> 新增哩程紀錄
	            </el-button>
	          </div>
	          <div>
	            <el-table :data="drivingTableData" empty-text="無資料" stripe  :default-expand-all="true">
	              <el-table-column label="項次" width="50">
	                <template slot-scope="scope">{{scope.$index+1}}</template>
	              </el-table-column>
	              <el-table-column label="交通工具" prop="carType">
	              </el-table-column>
	              <el-table-column label="" type="expand" >
	                <template slot-scope="scope">
	                  <div v-if="scope.row.distance > 0" >
	                    <p class="mt-10 ml-10">
	                      起: {{scope.row.startAddress}}<br>
	                      迄: {{scope.row.endAddress}}
	                    </p>
	                    <p class="mt-10 ml-10">
	                      哩程: {{scope.row.distance}} 公里
	                    </p>
	                  </div>
	                </template>
	              </el-table-column>

	              <el-table-column label="操作" width="120" v-if="basicForm.status === 'draft'">
	                <template slot-scope="scope1">
	                  <el-button type="primary" circle @click="handleEditCust_driving(scope1.row)"><i class="el-icon-edit"></i></el-button>

	                  <el-popconfirm
	                      class="ml-10 popconfirm-bg"
	                      title="確定刪除此筆資料嗎?"
	                      confirm-button-text="確定"
	                      cancel-button-text="取消刪除"
	                      icon="el-iconf-info"
	                      icon-color="red"
	                     @confirm="handleDelete_driving(scope1.row.id)"
	                  >
	                    <el-button type="danger" slot="reference" circle> <i class="el-icon-delete"></i></el-button>
	                  </el-popconfirm>
	                </template>
	              </el-table-column>
	            </el-table>

	            <el-row class="mt-10 mb-10 pl-20 pr-20"> 
	              <el-col :xs="24" :sm="24" :lg="24">
	                  <div class="text-right">總計公里數 : {{totalKm}} 公里</div>
	                </el-col>
	            </el-row>

	          </div>
	        </el-card>
	      </el-main>
	    </el-col>
	  </el-row>

	  <!-- 哩程 -->
	  <el-row v-if="editDriving" class="editing-form">
	  	<el-col :xs="24" :sm="24" :lg="24">
	  		<el-card>
	  			
		  			<el-form class="myform" label-position="top" :model="driving_form" ref="driving_form" :rules="drivingFormRules">
				      <el-row>
				        <el-col :xs="24" :sm="24" :md="12">
				          <el-form-item label="汽車/機車" prop="carType">
				            <el-select v-model="driving_form.carType" placeholder="請選擇">
				              <el-option label="汽車" value="汽車"></el-option>
				              <el-option label="機車" value="機車"></el-option>
				            </el-select>
				          </el-form-item>
				        </el-col>
				      </el-row>

				      <el-row >
				        <el-col :xs="24" :sm="24" :md="8" style="margin-right: 10px;">
				          <el-form-item label="開始地點" prop="startAddress">
				            <el-input placeholder="行程開始地址" v-model="driving_form.startAddress"></el-input>
				          </el-form-item>
				        </el-col>
				        <el-col :xs="24" :sm="24" :md="8" style="margin-right: 10px;">
				          <el-form-item label="結束點地" prop="endAddress">
				            <el-input placeholder="行程結束地址" v-model="driving_form.endAddress"></el-input>
				          </el-form-item>
				        </el-col>
				        <el-col :xs="24" :sm="24" :md="2" style="margin-right: 10px;">
				          <el-form-item label="公里" prop="distance">
				            <el-input v-model="driving_form.distance"></el-input>
				          </el-form-item>
				        </el-col>
				        <el-col :xs="24" :sm="24" :md="2">
				          <el-form-item label="動作">
				            <el-button size="small" type="primary" @click="findDistance()">計算公里數</el-button>
				          </el-form-item>
				        </el-col>
				      </el-row>
				    </el-form>
				    </el-card>
				    <div class="mt-20 mb-20 fr">
				      <el-button @click="cancelAddDriving">取 消</el-button>
				      <el-button type="primary" @click="saveDriving('driving_form')">確 定</el-button>
				    </div>
				  
	  			
	  	</el-col>
	  </el-row>

	  <!--    簽核紀錄-->
	  <el-row v-if="!inEditingMode">
	    <el-col :xs="24" :sm="24" :lg="24" v-if="basicForm.status !== 'draft'" class="mt-20">
	      <el-main>
	        <el-card class="box-card">
	          <div slot="header" class="clearfix">
	            <span>簽核紀錄</span>
	          </div>
	          <div>
	            <el-table :data="historyTableData" empty-text="無資料" stripe :default-expand-all="true">
	              <el-table-column label="時間" prop="updatedAt" width="170">
	                <template slot-scope="scope">
	                  <p>簽核時間 :</p>
	                  <p>{{ scope.row.updatedAt | fmtDateTime }}</p>
	                  <p class="mt-10">{{ scope.row.signerObj.username }}</p>
	                </template>
	              </el-table-column>
	              <el-table-column label="結果" prop="signResult">
	                <template slot-scope="scope">
	                  <el-tag v-if="scope.row.signResult === 'N'" type="danger">{{ scope.row.signResult | signResult }}</el-tag>
	                  <el-tag v-else>{{ scope.row.signResult | signResult }}</el-tag>
	                </template>
	              </el-table-column>
	              

	              <el-table-column label="" type="expand" >
	                <template slot-scope="scope">
	                  <p>簽核備註 : {{ scope.row.notes }}</p>
	                </template>
	              </el-table-column>
	            </el-table>

	          </div>
	        </el-card>
	      </el-main>
	    </el-col>
	  </el-row>


	</div>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'
import dayjs from "dayjs"
import axios from "axios";

export default {
	name: 'ReqMilesPage',
	components:{
		Breadcrumb
	},
	computed: {
    ...mapState('login', ['userInfo']),
    canEdit() {
      return this.basicForm.status === 'draft' || this.basicForm.status === 'reject'
    },
    inEditingMode(){
      return this.editMode || this.editDriving
    }
  },
	data(){
		let checkName = (rule, value, callback) => {
	    if (value === '' || value === null || typeof value === 'undefined') {
	      callback(new Error('請輸入資料'))
	    } else {
	      callback()
	    }
	  }
	  let validateNumber = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('數字必須大於 0'));
      } else {
        callback();
      }
    }

  	return {
  		from:'',
  		editDriving: false,
  		editMode: false,
      basicForm: {
        id: '',
        title: '',
        startDate: '',
        userObj: {
          username:''
        },
        hasMile:'Y',
        status:'',
        reqMilesNo:'',
        relatedTodoId:''
      },

      
      form: {
        mytodoId: ''
      },

      historyTableData: [],

      rules: {
        title: [{validator: checkName, trigger: 'change'}],
        startDate: [{validator: checkName, trigger: 'change'}],
        relatedTodoId: [{validator: checkName, trigger: 'change'}]
      },

      dailyRecordTableData:[],

      btnCount:0,
      drivingTableData:[],
      driving_form: {
        mytodoId: '',
        carType:'',
        startMile:0,
        endMile:0,
        startAddress:'',
        endAddress:'',
        distance:0
      },
      
      totalKm: 0.0,
      drivingFormRules:{
	        carType: [{required: true, validator: checkName, trigger: 'change'}],
	        startAddress: [{required: true, validator: checkName, trigger: 'change'}],
	        endAddress: [{required: true, validator: checkName, trigger: 'change'}],
	        distance: [
	          {required: true, validator: checkName, trigger: 'change'},
	          {validator: validateNumber, trigger: 'blur' }
	        ]
	      }
  	}
	},
	methods:{
		goBack() {
      this.$router.push('/daily/miles')
    },
    goBackReport() {
      this.$router.push('/report/req-miles-statistic') //回哩程補貼統計
    },
    handleDraft(formName) {
			this.handleSubmitForm(formName)
    },
    handleSubmitForm(formName) {
    	this.$refs[formName].validate(async valid => {
        if (valid) {
        	this.request.post("/todo", this.basicForm).then(res => {
		        if (res.code === '200') {
		          this.formDefault()
		          this.showResult('success', '資料更新成功.')
		        } else {
		          this.showResult('error', '資料更新失敗.')
		        }
		      })
        }
      })
    },
    formDefault() {
      this.request.get("/todo/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.basicForm = res.data
          if (this.basicForm.relatedTodoId == 0) {
          	this.basicForm.relatedTodoId = ''
          }
          this.loadCustomerHistoryData_driving()
        } else {
          this.showResult('error', '撈資料失敗')
        }
      })
      this.form.userId = this.userInfo.id
      // this.form.todoType = this.getTodoType()
    },
    handleSign(formName) {
    	this.$refs[formName].validate(async valid => {
    		if (valid) {
    			this.$confirm('請確認資料是否已完成填寫，當按下「確定」後將呈主管簽核', '提醒', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.basicForm.status = "review"
            this.request.post("/todo/signoff", this.basicForm).then(res => {
              if (res.code === '200') {
                this.showResult('success', '表單送簽核成功')
                this.$nextTick(()=>{
                    this.goBack()
                 })
              } else {
                this.showResult('error', '表單送簽核失敗')
              }
            })
          }).catch(() => {

          });
        }
    	})
    },
    loadJobSignHistory() {
      this.request.get("/job/signoff/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.historyTableData = res.data
        } else {
          this.showResult('error', '客戶拜訪簽核紀錄撈取失敗')
        }
      })
    },

    loadDailyTodo(){
    	let query = {
    		pageNum:0,
    		pageSize:20,
    		queryField: 'req_miles',
    		keyword: 'close'
    	}
    	this.request.get("/todo/page",{params: query}).then(res => {
        if (res.code === '200') {
          this.dailyRecordTableData = res.data.records
        } else {
          this.showResult('error', '客戶拜訪簽核紀錄撈取失敗')
        }
      })
    },

    cookLabel(item){
    	//`${item.startDate | fmtDate}-${item.title}`
    	return dayjs(item.startDate).format('YYYY-MM-DD') + ' ' + item.title

    },

    //處理哩程相關
    cancelAddDriving(){
      this.editDriving = false
    },
    handleAddDriving(){
      this.editDriving = true
      this.driving_form.id = null
      // this.driving_form.fileList = []
      // this.driving_form.fileNotes = []
      this.btnCount = 0
      this.driving_form.startAddress = ''
      this.driving_form.endAddress = ''
      this.driving_form.distance = 0
    },
    handleEditCust_driving(rowData) {
      this.editDriving = true
      this.driving_form = rowData
      this.driving_form.fileList = []
      this.driving_form.fileNotes = []
      // // this.driving_form.fileListDisplay = []
      // this.btnCount = 0
    },
    handleDelete_driving(id) {
      this.request.delete("/todo/driving/history/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadCustomerHistoryData_driving()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },
    loadCustomerHistoryData_driving() {
    	console.log('loadCustomerHistoryData_driving:', this.driving_form.mytodoId)
      this.request.get("/todo/driving/history/" + this.driving_form.mytodoId).then(res => {
        if (res.code === '200') {
          this.drivingTableData = res.data
          
          if (res.data.length > 0) {
            // this.basicForm.hasMile = 'Y'

            let km = 0.0
            res.data.forEach((element) => {
              if (element.startMile == 0) { //新版哩程計算方式
                km += element.distance
              } else { //舊版
                km += element.endMile - element.startMile
              }
            });
            this.totalKm = km.toFixed(1)

          } else {
            // this.basicForm.hasMile = 'N'
          }
        } else {
          this.showResult('error', '哩程紀錄撈取失敗')
        }
      })
    },
    removeHistoryFile_driving(id) {
      console.log('removeHistoryFile_driving')
      this.request.delete("/todo/driving/history/file/" + id).then(res => {
        if (res.code === '200') {
          this.loadCustomerHistoryData_driving()
          this.showResult('success', '附件刪除成功.')
        } else {
          this.showResult('error', '附件刪除失敗.')
        }
      })
    },
    async findDistance(){
      let startAddress = this.driving_form.startAddress
      let endAddress = this.driving_form.endAddress
      let carType = this.driving_form.carType

      let query = {
        startAddress,
        endAddress,
        carType
      }
      axios.get('/distancematrix-api/distanceSearch', { params: query })
        .then((res) => {
          if (res.status === 200) {
            console.log(res.data)
            const distance = res.data.rows[0].elements[0].distance.text
            const duration = res.data.rows[0].elements[0].duration.text
            let distanceDisplay = distance.substring(0,distance.indexOf(' 公里'))
            this.driving_form.distance = distanceDisplay
          }
        })
        .catch((error) => { 
          console.error(error) 
          this.showResult('error', '輸入的資料無法取得距離')
        })
        .finally(() => {})
    },

    saveDriving(formName){
      console.log(this.driving_form)

      this.$refs[formName].validate(async valid => {
        
        if (valid) {
          try {
            this.request.post("/todo/driving/history", this.driving_form).then(res => {
              if (res.code === '200') {
                this.editDriving = false
                this.loadCustomerHistoryData_driving()

                this.$nextTick(()=>{
                  this.showResult('success', '新增成功')
                  document.getElementById("add_driving_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
                })
              } else {
                this.showResult('error', res.message)
              }
            })
          } catch (e) {
            this.showResult('success', '資料更新失敗')
          }
        }
      })

    },
	},
	mounted(){
		this.form.mytodoId = this.$route.params.mytodoId
    this.driving_form.mytodoId = this.$route.params.mytodoId

    let from = this.$route.query.from
    if (typeof from === 'undefined') {
      this.from = ''
    } else {
      this.from = from
    }

    this.loadJobSignHistory()

    //設定一些欄位預設值
    this.formDefault()

    //抓過去20天的日報
    this.loadDailyTodo()

	}
}

</script>

<style scoped>
	
</style>